export function constantZero() {
  return 0;
}

export default function(x) {
  return function() {
    return x;
  };
}



//////////////////
// WEBPACK FOOTER
// ../~/d3-hierarchy/src/constant.js
// module id = JuqG
// module chunks = 0